import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/attributes/translation.updateTypeValue.mutation.gql"
import type {
  TranslationUpdateTypeValueMutation,
  TranslationUpdateTypeValueMutationVariables,
} from "@/v2-backoffice-client/translation/attributes/__types__/translation.updateTypeValue.mutation"

type Options = MutationHookOptions<
  TranslationUpdateTypeValueMutation,
  TranslationUpdateTypeValueMutationVariables
>

export function useTranslationUpdateTypeValueMutation(options?: Options) {
  return useMutation<
    TranslationUpdateTypeValueMutation,
    TranslationUpdateTypeValueMutationVariables
  >(mutation, options)
}
